import {gsap} from "gsap";

window.addEventListener("load", () => {
    const submenuContainer = document.querySelector<HTMLElement>(".HeaderComponent .submenuContainer")
    const profileName = document.querySelector<HTMLElement>(".HeaderComponent .profileName")
    const profilePicture = document.querySelector<HTMLElement>(".HeaderComponent .imgContainer")
    const submenu = document.querySelector<HTMLElement>(".HeaderComponent .submenu")

    function submenuClick() {
        if (submenu.style.opacity === "1") {
            gsap.to(submenu, {
                opacity: 0,
                duration: 0.2,
                y: "+=10",
            })
        } else {
            gsap.to(submenu, {
                opacity: 1,
                duration: 0.2,
                y: "-=10",
            })
        }
    }

    function windowClick() {
        if (submenu.style.opacity=== "1" && !submenuContainer.matches(':hover')) {
            gsap.to(submenu, {
                opacity: 0,
                duration: 0.2,
                y: "+=10",
            })
        }
    }

    function windowScroll() {
        if (submenu.style.opacity=== "1") {
            gsap.to(submenu, {
                opacity: 0,
                duration: 0.2,
                y: "+=10",
            })
        }
    }

    profileName.addEventListener("click", submenuClick)
    profilePicture.addEventListener("click", submenuClick)
    window.addEventListener("click", windowClick)
    window.addEventListener("scroll", windowScroll)

    submenu.style.width = (submenu.offsetWidth + 3) + "px";
})